import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Inicio from './Inicio';
import Nosotros from './Nosotros';
import NuestroTrabajo from './NuestroTrabajo';
import Contacto from './Contacto';
import Proyecto from './Proyecto';

function Routes(props) {
    return ( 
        <Switch>
                <Route exact path="/" component={Inicio}/>
                <Route exact path="/nosotros" component={Nosotros}/>
                <Route exact path="/nuestrotrabajo" render={(routeProps) => (<NuestroTrabajo {...routeProps} showBusqueda={props.showBusqueda} setShowBusqueda={props.setShowBusqueda}/>)}/>
                <Route exact path="/contacto" component={Contacto}/>
                <Route exact path="/proyecto" component={Proyecto}/>
                <Route exact path="*" component={() => <Redirect to={'/'}/>}/>
        </Switch>
     );
}

export default Routes;